import React from 'react';
import { Link } from 'react-router';
import SEO from '../components/SEO';
import FlyMateModeShell from '../components/flymate/FlyMateModeShell';
import { FLYMATE_OG_IMAGE, SITE_URL } from '../seo-data.js';

const FlyMatePage: React.FC = () => {
  return (
    <>
      <SEO
        title="FlyMate Aviation AI Assistant for ICAO, AIM, eAIP, and Compliance"
        description="FlyMate is AviaGov's aviation AI assistant for grounded ICAO, AIM, AIS, eAIP, PANS-OPS, compliance, and aviation message support with source-backed answers for ANSPs, CAAs, and regulated aviation teams."
        canonical={`${SITE_URL}/flymate`}
        ogType="website"
        ogImage={FLYMATE_OG_IMAGE}
        keywords={[
          'FlyMate',
          'aviation AI',
          'aviation AI assistant',
          'ICAO AI assistant',
          'AI for ANSP',
          'CAA AI assistant',
          'AI for AIM',
          'eAIP AI assistant',
          'grounded aviation AI',
        ]}
      />
      <section className="bg-slate-950 border-b border-white/10 px-4 py-14">
        <div className="mx-auto max-w-6xl">
          <div className="max-w-3xl">
            <div className="mb-4 text-xs font-bold uppercase tracking-[0.22em] text-accent">FlyMate aviation AI</div>
            <h1 className="mb-5 text-4xl font-bold leading-tight text-white md:text-5xl">
              Meet the FlyMate team. Aviation answers, grounded in evidence.
            </h1>
            <p className="text-lg leading-8 text-slate-400">
              Ask FlyMate Manager a question and it will route you to the right specialist across AIM, NOTAM, flight planning, procedures, safety, and training. Public-grounded mode uses only eligible global knowledge-base content; authenticated enterprise workflows remain inside the AviaGov platform.
            </p>
          </div>
          <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3">
            <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5">
              <h2 className="mb-2 text-lg font-bold text-white">ICAO-grounded answers</h2>
              <p className="text-sm leading-6 text-slate-400">
                Designed for aviation teams that need source-backed support instead of generic AI responses.
              </p>
            </div>
            <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5">
              <h2 className="mb-2 text-lg font-bold text-white">Specialist agent routing</h2>
              <p className="text-sm leading-6 text-slate-400">
                FlyMate Manager presents the most relevant platform specialist while preserving a strict read-only boundary.
              </p>
            </div>
            <div className="rounded-xl border border-white/10 bg-white/[0.03] p-5">
              <h2 className="mb-2 text-lg font-bold text-white">A clear public boundary</h2>
              <p className="text-sm leading-6 text-slate-400">
                Public-grounded mode has no login, uploads, saved chats, tenant data, drafts, approvals, or operational mutations.
              </p>
            </div>
          </div>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a href="#flymate-app" className="rounded-xl bg-accent px-6 py-3 text-center font-bold text-primary">
              Start FlyMate
            </a>
            <Link to="/modules/ai-assistant" className="rounded-xl border border-white/10 px-6 py-3 text-center font-bold text-white hover:bg-white/5">
              Aviation AI overview
            </Link>
          </div>
        </div>
      </section>
      <div id="flymate-app">
        <FlyMateModeShell />
      </div>
    </>
  );
};

export default FlyMatePage;
